module.exports = __webpack_public_path__ + "img/team-avatar.0063797c.png";